import React from "react";

function InvoiceStatusFilter(props) {
  const {
    statusList,
    filter,
    onStatusChecked,
    onStatusClear,
    statusTitle = undefined,
  } = props;

  return (
    <>
      {statusList === undefined && <></>}
      {statusList && (
        <div className="filter-status">
          <div className="btn-group pe-2 pt-1 rounded-1 align-items-center">
            <button
              type="button"
              className="btn btn-transparent shadow-none dropdown-toggle mr-2 dropdown-toggle-split"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-auto-close="outside"
              style={
                filter.InvoiceStatus.length > 0
                  ? { color: "#264EA7" }
                  : { color: "#A4B9E8" }
              }
            >
              <span className="mx-1 text">
                {statusTitle ?? "Payment Status"}
              </span>
              <span className="badge">
                {filter.InvoiceStatus.length > 0 && filter.InvoiceStatus.length}
              </span>
            </button>
            <div className="dropdown-menu border-0 p-1 py-1">
              {statusList?.map((item, index) => {
                return (
                  <div
                    className="publisher-filter-list px-4 py-2 pb-2 "
                    key={index}
                  >
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={item}
                        id={`date_${index}`}
                        onChange={(ev) => onStatusChecked(ev)}
                        checked={filter.InvoiceStatus.includes(item)}
                      />
                      <label
                        className="form-check-label fw-filter"
                        htmlFor={`date_${index}`}
                      >
                        {item}
                      </label>
                    </div>
                  </div>
                );
              })}
              {filter.InvoiceStatus.length > 0 && (
                <div className="m-2">
                  <button
                    onClick={onStatusClear}
                    className="button filter-actions clear-all"
                  >
                    Clear
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InvoiceStatusFilter;
